import addFavorite from "./addFavorite"
import removeFavorite from "./removeFavorite"
import getFavorite from "./getFavorite"
import countFavorites from "./countFavorites"

const favorites = { addFavorite, removeFavorite, getFavorite, countFavorites }

export default favorites
